import { css } from 'styled-components';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';

const styles = {
  listBig: css`
    ${Mixins.resetList()};

    li {
      &:before {
        content: '•';
        color: ${Colors.light_gray};
        float: left;
        margin-left: -1em;
        font-size: 1.2em;
      }
    }
  `,

  listMini: css`
    ${Mixins.resetList()};

    li {
      &:before {
        content: '•';
        color: ${Colors.light_gray};
        float: left;
        margin-left: -0.9em;
        font-size: 0.9em;
      }
    }
  `,

  listBlog: css`
    ${Mixins.resetList()};
    li {
      list-style-type: none;
      position: relative;

      &:before {
        content: '•';
        position: absolute;
        left: -15px;
      }
    }
  `,

  a: css`
    ${Mixins.transition('color')};
    ${Mixins.resetLink()};
    color: ${Colors.main_blue};
    outline: none;
    font-weight: 400;

    &:hover {
      color: ${Colors.electric_blue};
    }
  `,
};

export const common = (style = 'list') => {
  const value = styles[style];

  if (value) {
    return value;
  } else {
    console.error(`${style} - This common style is not available`);
    return '';
  }
};
